package com.essntl.uikit.components.tooltip

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

@Composable
internal actual fun EsTooltipPlatform(
    text: String,
    modifier: Modifier,
    content: @Composable () -> Unit
) {
    content()
}